// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/FormFieldGroup/index.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';

import {Basic} from './basic.story';
import {Disabled} from './disabled.story';
import {Invalid} from './invalid.story';
import {Layout} from './layout.story';

const basic = {
  rendered: <Basic />,
  source: `<FormFieldGroup legend="Full name" description="Enter your full name">
  <TextField label="First name" placeholder="First name" hiddenElements={['label']} />
  <TextField label="Last name" placeholder="Last name" hiddenElements={['label']} />
</FormFieldGroup>`,
};

const disabled = {
  rendered: <Disabled />,
  source: `<FormFieldGroup legend="Disabling" disabled>
  <TextField label="Disabled" placeholder="Disabled" hiddenElements={['label']} />
  <TextField label="Not disabled" placeholder="Not disabled" disabled={false} hiddenElements={['label']} />
</FormFieldGroup>`,
};

const invalid = {
  rendered: <Invalid />,
  source: `<FormFieldGroup legend="Full name" description="Enter your full name" invalid>
  <TextField label="First name" value="Tim" placeholder="First name" hiddenElements={['label']} />
  <TextField label="Last name" error="Last name missing" placeholder="Last name" hiddenElements={['label']} />
</FormFieldGroup>`,
};

const layout = {
  rendered: <Layout />,
  source: `<FormFieldGroup legend="Spiffy settings" layout="column">
  <Switch label="Enable transmogrifier" description="Scientific progress goes 'boink'" />
  <Switch label="Set zorcher on 'shake and bake'" description="Note: blasters may be useless against slime" />
</FormFieldGroup>`,
};

export const FormFieldGroupExamples = {
  basic,
  disabled,
  invalid,
  layout,
};
